import React from 'react'
import { PageTitle, Paragraph, ParaTitle, Pagination } from "../common";
import './Updates.css';

const Updates_3_35_0 = () => {
  return (
    <div>
      <PageTitle title='3.35.0' />

      <ParaTitle paraTitle='Event Categories & Reports' />
      <Paragraph paragraph='2024-10-02' />
      <ParaTitle paraTitle='Added:' />
      <ul>
        <li>
          Fall analysis reports
          {/* <p></p> */}
        </li>

        <li>
          Added label explaining draft deletion timeline(#1083)
          {/* <p></p> */}
        </li>

      </ul>
      <ParaTitle paraTitle='Changed:' />
      <ul>
        <li>
          Ability to run the Export Events tool on all events
        </li>

        <li>Hide inactive managers on Facility Management page</li>
        <li>Trending report needs to be line chart by default</li>
        <li>Correct form spelling</li>
        <li>Update question flows on PF1112, adding 2 options</li>
        <li>Run reports using new category format</li>
      </ul>

      <ParaTitle paraTitle='Removed:' />
      <ul>
        <li>
          Event location summary bug not showing Other
        </li>

        <li>
          Text reports not showing Other category
        </li>
      </ul>
      <Pagination
        pagination={{
          prev: { name: 'Updates: 3.36.0', link: '/updates/3.36.0' },
          next: { name: 'Events Summary', link: '/general/events-summary' }
        }}
      />
    </div>

  )
}

export default Updates_3_35_0;